import { useState, type FormEvent } from 'react'

import { api, ErrorApi, type Cliente } from '../api'

/** Para el cliente que se creo sin cedula/RUC: se completa despues, sin salir de la ficha. */
export function AgregarIdentificacion({ clienteId, alGuardar }: { clienteId: string; alGuardar: (c: Cliente) => void }) {
  const [abierto, setAbierto] = useState(false)
  const [valor, setValor] = useState('')
  const [error, setError] = useState('')
  const [enviando, setEnviando] = useState(false)

  const enviar = async (e: FormEvent) => {
    e.preventDefault()
    setError('')
    setEnviando(true)
    try {
      const { cliente } = await api.completarIdentificacion(clienteId, valor)
      alGuardar(cliente)
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'No se pudo guardar.')
    } finally {
      setEnviando(false)
    }
  }

  if (!abierto) {
    return (
      <>
        <span className="suave">Sin registrar</span>{' '}
        <button type="button" className="enlace" onClick={() => setAbierto(true)}>
          Agregar
        </button>
      </>
    )
  }
  return (
    <form onSubmit={enviar}>
      <input value={valor} onChange={(e) => setValor(e.target.value)} inputMode="numeric" placeholder="10 o 13 dígitos" autoFocus />{' '}
      <button className="primario pequeno" disabled={enviando || valor.trim() === ''}>
        Guardar
      </button>{' '}
      <button type="button" className="enlace" onClick={() => setAbierto(false)}>
        Cancelar
      </button>
      {error && <p className="error">{error}</p>}
    </form>
  )
}
